<table>
  <thead>
    <tr>
      @for (column of columns; track column) {
        <th [style.min-width.px]="column.minWidth">
          <div class="column">
            @if (column.sortable) {
              <coin-v2-button
                icon="unfold_more"
                iconPos="right"
                type="outline"
                class="text sort-button"
                [matMenuTriggerFor]="moreActionsMenu"
                [text]="column.displayName"
                [class.sorting-active]="sortedBy === column.key"></coin-v2-button>
              <mat-menu
                #moreActionsMenu
                class="sort-overlay mat-elevation-z3"
                role="menu">
                <div
                  class="menu-item"
                  role="menuitem">
                  <coin-v2-button
                    icon="arrow_drop_up"
                    type="outline"
                    class="text menu-button"
                    [text]="'general.table.sort-ascending' | translate"
                    (click)="sort(column.key, 'asc')"></coin-v2-button>
                </div>
                <div
                  class="menu-item"
                  role="menuitem">
                  <coin-v2-button
                    icon="arrow_drop_down"
                    type="outline"
                    class="text menu-button"
                    [text]="'general.table.sort-descending' | translate"
                    (click)="sort(column.key, 'desc')"></coin-v2-button>
                </div>
              </mat-menu>
            }
          </div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    <tr
      class="divider"
      aria-hidden="true"></tr>
    <ng-content></ng-content>
  </tbody>
</table>
